import { render, staticRenderFns } from "./WidgetDemo.vue?vue&type=template&id=cf957c70"
import script from "./WidgetDemo.vue?vue&type=script&lang=js"
export * from "./WidgetDemo.vue?vue&type=script&lang=js"
import style0 from "./WidgetDemo.vue?vue&type=style&index=0&id=cf957c70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports